const CallToAction = ({
  content: { content, url, color = 'red' },
  className = '',
  newTab,
}) => (
  <div className={`contentful__container__call_to_action ${className}`}>
    <a
      href={url}
      className={`cef-btn cef-btn--xl cef-btn--${color} fw-600 fs-18`}
      target={newTab && '_blank'}
      rel={newTab && 'noreferrer'}>
      {content}
    </a>
  </div>
);

export default CallToAction;
